export var getModalMountNode = function () {
    return document.getElementById('pinwheel-link');
};
